// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./back.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-page {
  min-height: 100vh;
  position: relative;
  z-index: 2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* 上半部分 - 透明区域 */
.top-section {
  min-height: 50vh;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px 40px;
  position: relative;
}

.top-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, 
    rgba(255, 182, 193, 0.6) 0%, 
    rgba(255, 192, 203, 0.5) 20%,
    rgba(255, 218, 224, 0.4) 50%,
    rgba(255, 240, 245, 0.3) 80%, 
    rgba(255, 255, 255, 0.2) 100%);
  z-index: 1;
}

.top-section > * {
  position: relative;
  z-index: 2;
}

/* 波浪线分割 */
.wave-divider {
  width: 100%;
  height: 200px;
  overflow: hidden;
  position: relative;
  z-index: 3;
  background: transparent;
  margin-top: -80px;
}

.wave-animation {
  display: flex;
  width: 400%;
  height: 100%;
  animation: wave-scroll 12s linear infinite;
}

.wave-animation svg {
  width: 25%;
  height: 100%;
  display: block;
  flex-shrink: 0;
}

@keyframes wave-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-25%);
  }
}

/* 下半部分 - 从下方粉色到中间白色渐变 */
.bottom-section {
  min-height: 50vh;
  background: linear-gradient(to top, 
    rgba(255, 182, 193, 0.9) 0%, 
    rgba(255, 192, 203, 0.8) 20%, 
    rgba(255, 205, 215, 0.7) 45%, 
    rgba(255, 228, 235, 0.5) 75%, 
    rgba(255, 240, 245, 0.4) 100%
  );
  padding: 40px 20px 20px 20px;
  position: relative;
}

.main-content {
  max-width: 1200px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
}

.hero-section {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.main-title {
  font-size: 3.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 20px;
  text-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);
}

.heart-icon {
  display: inline-block;
  animation: heartbeat 2s ease-in-out infinite;
  margin: 0 15px;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.main-subtitle {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.98);
  margin-bottom: 30px;
  font-weight: 500;
  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8);
  letter-spacing: 0.5px;
}

/* 头像容器样式 */
.avatars-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;
  margin-bottom: 20px;
  margin-top: 40px;
}

.avatar-left, .avatar-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.4);
  border: 3px solid rgba(255, 255, 255, 0.3);
  animation: float 3s ease-in-out infinite;
  overflow: hidden;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.male-avatar {
  animation-delay: 0s;
}

.female-avatar {
  animation-delay: 1.5s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.avatar-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  font-weight: 500;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.love-counter {
  flex: 0 1 auto;
  text-align: center;
  min-width: 300px;
}

.love-days {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  margin: 20px 0 40px 0;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  padding: 12px 20px;
  border-radius: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.4);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.3);
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.highlight-number {
  color: #ff1493;
  font-weight: 700;
  font-size: 1.3rem;
  text-shadow: 0 0 10px rgba(255, 20, 147, 0.5);
}

.love-quote {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 15px 30px;
  border-radius: 25px;
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
}

.menu-grid {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 30px;
  margin-top: -60px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.menu-row {
  display: grid;
  gap: 12px;
}

.menu-row.first-row {
  grid-template-columns: repeat(4, 1fr);
}

.menu-row.second-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 0 auto;
  max-width: 350px;
}

/* 让第二排的按钮有足够宽度显示文字 */
.menu-row.second-row .menu-item {
  flex: 1 1;
  min-width: 160px;
}

.menu-item {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border-radius: 18px;
  padding: 16px 20px;
  text-decoration: none;
  color: #333;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.4);
  position: relative;
  overflow: hidden;
  min-height: 80px;
  max-height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  box-shadow: 0 8px 32px rgba(255, 182, 193, 0.15), 
              0 2px 8px rgba(255, 255, 255, 0.1);
}

.menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 192, 203, 0.1), transparent);
  transition: left 0.8s ease;
}

.menu-item:hover::before {
  left: 100%;
}

.menu-item:hover {
  transform: translateY(-6px) scale(1.03);
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 192, 203, 0.4);
  box-shadow: 0 12px 40px rgba(255, 182, 193, 0.25), 
              0 4px 16px rgba(255, 255, 255, 0.2),
              0 0 0 1px rgba(255, 192, 203, 0.1);
}

.menu-icon {
  font-size: 1.6rem;
  margin-right: 15px;
  margin-bottom: 0;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  transition: all 0.4s ease;
  flex-shrink: 0;
}

.menu-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.menu-title {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 3px;
  text-shadow: none;
  color: #2c3e50;
  line-height: 1.3;
  letter-spacing: 0.3px;
}

.menu-description {
  font-size: 0.78rem;
  opacity: 0.85;
  margin-bottom: 0;
  line-height: 1.3;
  text-shadow: none;
  color: #5a6c7d;
}

.menu-arrow {
  font-size: 1.2rem;
  font-weight: bold;
  opacity: 0;
  transition: all 0.4s ease;
  transform: translateX(-8px);
  color: #e91e63;
  filter: drop-shadow(0 1px 2px rgba(233, 30, 99, 0.3));
}

.menu-item:hover .menu-arrow {
  opacity: 1;
  transform: translateX(0);
}

.menu-item:hover .menu-icon {
  transform: scale(1.15);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}

.menu-item:hover .menu-title {
  color: #1a252f;
}

.menu-item:hover .menu-description {
  color: #34495e;
  opacity: 0.9;
}

.footer-message {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
  margin-top: 80px;
  margin-bottom: 100px;
  padding: 25px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-section {
    min-height: 40vh;
    padding: 20px 15px 15px;
  }
  
  .bottom-section {
    min-height: 60vh;
    padding: 30px 15px;
  }
  
  .wave-divider {
    height: 160px;
    margin-top: -60px;
  }
  
  .avatars-container {
    flex-direction: row;
    gap: 25px;
    margin-top: 30px;
    justify-content: center;
  }
  
  .avatar {
    width: 60px;
    height: 60px;
    font-size: 2rem;
  }
  
  .love-days {
    font-size: 1.2rem;
    padding: 12px 20px;
  }
  
  .highlight-number {
    font-size: 1.4rem;
  }
  
  .main-title {
    font-size: 2.2rem;
  }
  
  .heart-icon {
    margin: 0 10px;
  }
  
  .main-subtitle {
    font-size: 1.1rem;
  }
  
  .menu-row.first-row {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .menu-row.second-row {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 0 auto;
    max-width: 100%;
  }
  
  .menu-row.second-row .menu-item {
    flex: 1 1;
    min-width: 210px;
    max-width: 260px;
  }
  
  .menu-item {
    padding: 15px 10px;
    min-height: 70px;
  }
  
  .menu-icon {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }
  
  .menu-title {
    font-size: 1rem;
  }
  
  .menu-description {
    font-size: 0.75rem;
  }
  
  .footer-message {
    font-size: 1rem;
    margin-top: 60px;
    margin-bottom: 80px;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .top-section {
    min-height: 35vh;
    padding: 15px 10px 10px;
  }
  
  .bottom-section {
    min-height: 65vh;
    padding: 20px 10px 10px 10px;
  }
  
  .footer-message {
    font-size: 0.9rem;
    margin-top: 50px;
    margin-bottom: 60px;
    padding: 20px;
  }
  
  .wave-divider {
    height: 140px;
    margin-top: -50px;
  }
  
  .avatars-container {
    gap: 20px;
    margin-top: 20px;
    flex-direction: row;
    justify-content: center;
  }
  
  .avatar {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }
  
  .main-title {
    font-size: 1.8rem;
  }
  
  .love-days {
    font-size: 1rem;
    padding: 10px 15px;
  }
  
  .highlight-number {
    font-size: 1.2rem;
  }
  
  .menu-row.first-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .menu-row.second-row {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 0 auto;
    max-width: 100%;
  }
  
  .menu-row.second-row .menu-item {
    flex: 1 1;
    min-width: 200px;
    max-width: 250px;
  }
  
  .love-quote {
    font-size: 1rem;
    padding: 12px 20px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/MainPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yDAAmC;EACnC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;kCAKgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB;;;;;;GAMC;EACD,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uEAAuE;EACvE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+CAA+C;EAC/C,0CAA0C;EAC1C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,+CAA+C;EAC/C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB;gDAC8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,sCAAsC;EACtC;;gDAE8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;AAEA,UAAU;AACV;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".main-page {\n  min-height: 100vh;\n  position: relative;\n  z-index: 2;\n  background-image: url('./back.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n/* 上半部分 - 透明区域 */\n.top-section {\n  min-height: 50vh;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px 40px;\n  position: relative;\n}\n\n.top-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, \n    rgba(255, 182, 193, 0.6) 0%, \n    rgba(255, 192, 203, 0.5) 20%,\n    rgba(255, 218, 224, 0.4) 50%,\n    rgba(255, 240, 245, 0.3) 80%, \n    rgba(255, 255, 255, 0.2) 100%);\n  z-index: 1;\n}\n\n.top-section > * {\n  position: relative;\n  z-index: 2;\n}\n\n/* 波浪线分割 */\n.wave-divider {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  position: relative;\n  z-index: 3;\n  background: transparent;\n  margin-top: -80px;\n}\n\n.wave-animation {\n  display: flex;\n  width: 400%;\n  height: 100%;\n  animation: wave-scroll 12s linear infinite;\n}\n\n.wave-animation svg {\n  width: 25%;\n  height: 100%;\n  display: block;\n  flex-shrink: 0;\n}\n\n@keyframes wave-scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-25%);\n  }\n}\n\n/* 下半部分 - 从下方粉色到中间白色渐变 */\n.bottom-section {\n  min-height: 50vh;\n  background: linear-gradient(to top, \n    rgba(255, 182, 193, 0.9) 0%, \n    rgba(255, 192, 203, 0.8) 20%, \n    rgba(255, 205, 215, 0.7) 45%, \n    rgba(255, 228, 235, 0.5) 75%, \n    rgba(255, 240, 245, 0.4) 100%\n  );\n  padding: 40px 20px 20px 20px;\n  position: relative;\n}\n\n.main-content {\n  max-width: 1200px;\n  width: 100%;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.hero-section {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.main-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 20px;\n  text-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);\n}\n\n.heart-icon {\n  display: inline-block;\n  animation: heartbeat 2s ease-in-out infinite;\n  margin: 0 15px;\n}\n\n@keyframes heartbeat {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.main-subtitle {\n  font-size: 1.3rem;\n  color: rgba(255, 255, 255, 0.98);\n  margin-bottom: 30px;\n  font-weight: 500;\n  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8);\n  letter-spacing: 0.5px;\n}\n\n/* 头像容器样式 */\n.avatars-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 40px;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n\n.avatar-left, .avatar-right {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.4);\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  animation: float 3s ease-in-out infinite;\n  overflow: hidden;\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.male-avatar {\n  animation-delay: 0s;\n}\n\n.female-avatar {\n  animation-delay: 1.5s;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n.avatar-label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1.1rem;\n  font-weight: 500;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.love-counter {\n  flex: 0 1 auto;\n  text-align: center;\n  min-width: 300px;\n}\n\n.love-days {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.95);\n  font-weight: 600;\n  margin: 20px 0 40px 0;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(15px);\n  padding: 12px 20px;\n  border-radius: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.4);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.3);\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.highlight-number {\n  color: #ff1493;\n  font-weight: 700;\n  font-size: 1.3rem;\n  text-shadow: 0 0 10px rgba(255, 20, 147, 0.5);\n}\n\n.love-quote {\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-style: italic;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  padding: 15px 30px;\n  border-radius: 25px;\n  display: inline-block;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin-bottom: 20px;\n}\n\n.menu-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-bottom: 30px;\n  margin-top: -60px;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.menu-row {\n  display: grid;\n  gap: 12px;\n}\n\n.menu-row.first-row {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.menu-row.second-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 auto;\n  max-width: 350px;\n}\n\n/* 让第二排的按钮有足够宽度显示文字 */\n.menu-row.second-row .menu-item {\n  flex: 1;\n  min-width: 160px;\n}\n\n.menu-item {\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(20px);\n  border-radius: 18px;\n  padding: 16px 20px;\n  text-decoration: none;\n  color: #333;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  position: relative;\n  overflow: hidden;\n  min-height: 80px;\n  max-height: 80px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n  box-shadow: 0 8px 32px rgba(255, 182, 193, 0.15), \n              0 2px 8px rgba(255, 255, 255, 0.1);\n}\n\n.menu-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 192, 203, 0.1), transparent);\n  transition: left 0.8s ease;\n}\n\n.menu-item:hover::before {\n  left: 100%;\n}\n\n.menu-item:hover {\n  transform: translateY(-6px) scale(1.03);\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(255, 192, 203, 0.4);\n  box-shadow: 0 12px 40px rgba(255, 182, 193, 0.25), \n              0 4px 16px rgba(255, 255, 255, 0.2),\n              0 0 0 1px rgba(255, 192, 203, 0.1);\n}\n\n.menu-icon {\n  font-size: 1.6rem;\n  margin-right: 15px;\n  margin-bottom: 0;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n  transition: all 0.4s ease;\n  flex-shrink: 0;\n}\n\n.menu-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.menu-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  margin-bottom: 3px;\n  text-shadow: none;\n  color: #2c3e50;\n  line-height: 1.3;\n  letter-spacing: 0.3px;\n}\n\n.menu-description {\n  font-size: 0.78rem;\n  opacity: 0.85;\n  margin-bottom: 0;\n  line-height: 1.3;\n  text-shadow: none;\n  color: #5a6c7d;\n}\n\n.menu-arrow {\n  font-size: 1.2rem;\n  font-weight: bold;\n  opacity: 0;\n  transition: all 0.4s ease;\n  transform: translateX(-8px);\n  color: #e91e63;\n  filter: drop-shadow(0 1px 2px rgba(233, 30, 99, 0.3));\n}\n\n.menu-item:hover .menu-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.menu-item:hover .menu-icon {\n  transform: scale(1.15);\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));\n}\n\n.menu-item:hover .menu-title {\n  color: #1a252f;\n}\n\n.menu-item:hover .menu-description {\n  color: #34495e;\n  opacity: 0.9;\n}\n\n.footer-message {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 500;\n  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);\n  margin-top: 80px;\n  margin-bottom: 100px;\n  padding: 25px;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .top-section {\n    min-height: 40vh;\n    padding: 20px 15px 15px;\n  }\n  \n  .bottom-section {\n    min-height: 60vh;\n    padding: 30px 15px;\n  }\n  \n  .wave-divider {\n    height: 160px;\n    margin-top: -60px;\n  }\n  \n  .avatars-container {\n    flex-direction: row;\n    gap: 25px;\n    margin-top: 30px;\n    justify-content: center;\n  }\n  \n  .avatar {\n    width: 60px;\n    height: 60px;\n    font-size: 2rem;\n  }\n  \n  .love-days {\n    font-size: 1.2rem;\n    padding: 12px 20px;\n  }\n  \n  .highlight-number {\n    font-size: 1.4rem;\n  }\n  \n  .main-title {\n    font-size: 2.2rem;\n  }\n  \n  .heart-icon {\n    margin: 0 10px;\n  }\n  \n  .main-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .menu-row.first-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .menu-row.second-row {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    margin: 0 auto;\n    max-width: 100%;\n  }\n  \n  .menu-row.second-row .menu-item {\n    flex: 1;\n    min-width: 210px;\n    max-width: 260px;\n  }\n  \n  .menu-item {\n    padding: 15px 10px;\n    min-height: 70px;\n  }\n  \n  .menu-icon {\n    font-size: 1.8rem;\n    margin-bottom: 10px;\n  }\n  \n  .menu-title {\n    font-size: 1rem;\n  }\n  \n  .menu-description {\n    font-size: 0.75rem;\n  }\n  \n  .footer-message {\n    font-size: 1rem;\n    margin-top: 60px;\n    margin-bottom: 80px;\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .top-section {\n    min-height: 35vh;\n    padding: 15px 10px 10px;\n  }\n  \n  .bottom-section {\n    min-height: 65vh;\n    padding: 20px 10px 10px 10px;\n  }\n  \n  .footer-message {\n    font-size: 0.9rem;\n    margin-top: 50px;\n    margin-bottom: 60px;\n    padding: 20px;\n  }\n  \n  .wave-divider {\n    height: 140px;\n    margin-top: -50px;\n  }\n  \n  .avatars-container {\n    gap: 20px;\n    margin-top: 20px;\n    flex-direction: row;\n    justify-content: center;\n  }\n  \n  .avatar {\n    width: 50px;\n    height: 50px;\n    font-size: 1.5rem;\n  }\n  \n  .main-title {\n    font-size: 1.8rem;\n  }\n  \n  .love-days {\n    font-size: 1rem;\n    padding: 10px 15px;\n  }\n  \n  .highlight-number {\n    font-size: 1.2rem;\n  }\n  \n  .menu-row.first-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n  \n  .menu-row.second-row {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    margin: 0 auto;\n    max-width: 100%;\n  }\n  \n  .menu-row.second-row .menu-item {\n    flex: 1;\n    min-width: 200px;\n    max-width: 250px;\n  }\n  \n  .love-quote {\n    font-size: 1rem;\n    padding: 12px 20px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
